import { render } from "./SelectSystem.vue?vue&type=template&id=5593d94a"
import script from "./SelectSystem.vue?vue&type=script&lang=js"
export * from "./SelectSystem.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__